<template>
    <div class="mod-config">
        <div style="border-radius: 30px">
            <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-row>
                  <el-form-item label="供应商名称" prop="venderName">
                        <el-input clearable size="mini" v-model="venderName" style="width: 150px " placeholder="供应商名称" @blur="getDataList"></el-input>
                    </el-form-item>
                  <el-form-item label="联系人" prop="venderContacts">
                    <el-input clearable size="mini" v-model="venderContacts" style="width: 150px " placeholder="联系人" @blur="getDataList"></el-input>
                  </el-form-item>
                  <el-form-item label="创建时间:" label-width="100px">
                    <el-date-picker v-model="createTimeForm" unlink-panels type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable @blur="getDataList">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="邀请状态" prop="inviteStauts" >
                        <el-select v-model="inviteStauts" clearable placeholder="请选择">
                            <el-option v-for="item in options1" :key="item.value" :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                  <el-form-item >
                    <el-button size="mini" @click="queryHandle()" icon="el-icon-search" style="margin-left:10px">查询</el-button>
                  </el-form-item>
                </el-row>
            </el-form>
        </div>
        <div v-loading="dataListLoading">
        <el-table :data="dataList" size="mini" :row-class-name="rowClassName"
                  :height="style.gridStyle.height" @selection-change="selectionChangeHandle"
                  :header-cell-style="{background:'#f5f5f5'}" border>
            <el-table-column align="center" v-model="something" type="selection" width="55">
            </el-table-column>
            <el-table-column header-align="center" label="序号" align="center" width="55">
                <template slot-scope="scope">
                    {{ scope.row.rowid }}
                </template>
            </el-table-column>
          <el-table-column prop="supcompanyCode" header-align="center" align="left" label="子公司" min-width="200">
            <template slot-scope="scope">
              {{ scope.row.supcompanyCode }}
            </template>
          </el-table-column>
          <el-table-column prop="supgroupCode" header-align="center" align="left" label="采购组" min-width="200">
            <template slot-scope="scope">
              {{ scope.row.supgroupCode }}
            </template>
          </el-table-column>
            <el-table-column prop="venderName" header-align="center" align="left" label="供应商名称" min-width="200">
                <template slot-scope="scope">
                    <el-button type="text" @click="venderUserDetail(scope.row)"> {{ scope.row.venderName }}</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="venderContacts" header-align="center" align="left" label="联系人" min-width="200">
            <template slot-scope="scope">
              {{ scope.row.venderContacts }}
            </template>
          </el-table-column>
            <el-table-column prop="venderTel" header-align="center" align="right" label="电话" min-width="160" >
              <template slot-scope="scope">
                {{ scope.row.venderTel }}
              </template>
          </el-table-column>
            <el-table-column prop="approveStore" header-align="center" align="right" label="审核得分" min-width="160" >
            <template slot-scope="scope">
              {{ scope.row.approveStore }}
            </template>
          </el-table-column>
            <el-table-column prop="approveClass" header-align="center" align="right" label="审核等级" min-width="160" >
              <template slot-scope="scope">
                {{ scope.row.approveClass }}
              </template>
          </el-table-column>
            <el-table-column prop="createTime" header-align="center" align="right" label="创建时间" min-width="160" >
              <template slot-scope="scope">
                {{ scope.row.createTime}}
              </template>
            </el-table-column>
            <el-table-column prop="inviteStauts" header-align="center" align="center" label="邀请状态" min-width="80">
            <template slot-scope="scope">
              <span style="color:#409EFF" v-if="scope.row.inviteStauts===0">未邀请</span>
              <span style="color:#67C23A" v-if="scope.row.inviteStauts===1">已邀请</span>
            </template>
          </el-table-column>
            <el-table-column prop="isPru" header-align="center" align="center" label="生产供应商" min-width="160" >
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.isPru" :true-label=1 :false-label=0 disabled></el-checkbox>
            </template>
          </el-table-column>
            <el-table-column prop="isGen" header-align="center" align="center" label="综合供应商" min-width="160" >
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.isGen" :true-label=1 :false-label=0 disabled></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column v-if="role||isAuth('supplier:supplierInquiry:invite')" header-align="center" align="center" label="操作" width="150px" >
                <template slot-scope="{row}">
                    <el-button v-if="role" type="text" size="small" @click="updateHandle(row)" icon="el-icon-edit">修改</el-button>
                    <el-button v-if="role" type="text" size="small" @click="deleteHandle(row)" class="button-danger" icon="el-icon-delete">删除</el-button>
                    <el-button  type="text" v-if="isAuth('supplier:supplierInquiry:invite')" size="small" @click="inviteHandle(row)" class="button-danger" icon="el-icon-user-solid">邀请</el-button>
                    <el-button  type="text" v-if="isAuth('supplier:supplierInquiry:complete') && row.inviteStauts === 0" size="small" @click="completeHandle(row)" class="button-danger" icon="el-icon-user-solid">已完善</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        </div>
        <!-- 弹窗 供应商 查看 / 新增 / 修改 -->

        <el-dialog title="供应商准入信息" width="60%" :visible.sync="dialogVisible"  @close='closeDialog'>
<!--          <el-tabs>-->
<!--            <el-tab-pane class="tab_style" :key="1" label="基本信息">-->
              <div style="margin-top: 30px;">
                <supplier-inquiry-view
                    v-if="supplierInquiryViewVisible"
                    ref="supplierInquiryView"
                    :venderinviteId="venderinviteId"
                    :temp="temp"
                    :showEditButton = 'showEditButton'
                ></supplier-inquiry-view>

                </div>
            <span slot="footer">
                <el-button type="primary" @click="dataFormSubmit()" :loading="submitLoading" size="mini" v-if="showEditButton">保 存</el-button>
                <el-button @click="dialogVisible = false" size="mini" v-if="!editflag">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import {listSupplierInquiry, listSupplierUpdate, listSupplierDelete,roleSearch,complete} from '@/controller/supplier'
    import {isAuth} from "../../../../utils/common";
    import SupplierInquiryView from "./supplier-view.vue";


    export default {
      components: {SupplierInquiryView},
        name:'SupplierInquiryIndex',
        data() {
            return {
                FILE_BIZ_TYPE:30,
                submitLoading:false,
                dialogVisible: false,
                dataForm: {
                    key: ''
                },
                flag: '',
                gpsStatusvalflag: '',
                supplierInquiryViewVisible:false,
                temp: {
                  venderName : '',
                  venderAdd : '',
                  isPru:'',
                  isGen:'',
                  supcompanyCode:'',
                  supgroupCode:'',
                  venderType:'',
                  venturePartner:'',
                  empNum:'',
                  venderEdge:'',
                  venderContacts : '',
                  venderTel : '',
                  venderMail : '',
                  productName:'',
                  approveIssue:'',
                  approveStore:'',
                  approveClass:'',
                  inviteStauts:'',
                  createTime:'',
                },
                dataList: [],//表格数据
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                venderinviteId: '',
                venderName: '',
                createTimeForm:null,
                inviteStauts : 0,
                venderContacts:'',
                venderCode: '',
                checkCreated: true,//暂放
                checkInvited: true,
                checkInvitedRecall: true,
                showEditButton : false,//编辑
                editflag:false,
                something: '',
                style: {
                    leftStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 325) + "px",
                        overflow: "auto"
                    },
                    rightStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 205) + "px"
                    },
                    gridStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 255) + "px"
                    }
                },
                options1: [{
                    value: 0,
                    label: '未邀请'
                }, {
                    value: 1,
                    label: '已邀请'
                }
                ],

                role:false
            }
        },
      //暂放 同潜在
        activated() {
            this.flag = this.$route.params.gpsStatusvalflag
            if (this.flag === "1") {
                this.checkCreated = true
                this.checkInvited = false
                this.checkInvitedRecall = false
            }
            if (this.$route.query && this.$route.query.gpsStatusval && this.$route.query.gpsStatusval.length > 0) {
                this.gpsStatusval = encodeURI(JSON.stringify(this.$route.query.gpsStatusval))
            } else {
                this.gpsStatusval = ''
            }
            this.getDataList()
        },
        methods: {
          isAuth,

            // 查询按钮
            queryHandle() {
                this.pageIndex = 1
                this.getDataList()
            },
            // 获取数据列表
            getDataList() {
              roleSearch({}).then(data => {
                if (data && data.code === '00') {
                  this.role = data.body.isIT
                }
              })
              this.dataListLoading = true
              listSupplierInquiry({
                    'pageNo': this.pageIndex,
                    'pageSize': this.pageSize,
                    "createTimeForm": this.createTimeForm,
                    'venderName': this.venderName,
                    'venderContacts': this.venderContacts,
                    'inviteStauts':this.inviteStauts
                }).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                }).catch((e) => {
                    console.log(e)
                }).finally(() => {
                    this.dataListLoading = false
                })
            },
            // 表单提交
            dataFormSubmit() {
                const data =  this.$refs.supplierInquiryView.getData()
                let params = {
                    'id': this.venderinviteId || undefined,
                    'venderName': data.venderName,
                    'isPru': data.isPru,
                    'isGen': data.isGen,
                }
                //对表单进行校验

                this.submitLoading = true
                    listSupplierUpdate(params).then(data => {
                        if (data && data.code === '00') {
                            this.submitLoading = false
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.dialogVisible = false
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.submitLoading = false
                            this.$message.error(data.msg)
                        }
                    }).catch(()=>{this.submitLoading = false})

            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            //多选
            selectionChangeHandle(val) {
                console.log(val)
                this.dataListSelections = val
            },
            inviteHandle(row){
              this.$router.push({
                path: '/supplier-supplierInvite',
                query: { action: 'create',data:row }
              })
            },

          // 删除
            deleteHandle(row) {
                // if (row.venderStatus == '1') {
                //     this.$message.info("已邀请状态不能删除！")
                // } else {

                  console.log(row.id)
                  this.$confirm(`确定进行删除操作?`, '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                  }).then(() => {
                      listSupplierDelete({
                          'id': row.id
                      }).then(data => {
                          if (data && data.code === '00') {
                              this.$message({
                                  message: '操作成功',
                                  type: 'success',
                                  duration: 1500,
                                  onClose: () => {
                                      this.getDataList()
                                  }
                              })
                          } else {
                              this.$message.error(data.msg)
                          }
                      })
                  })
                // }
            },

          completeHandle(row) {
            console.log(row.id)
            this.$confirm(`确定要把这条件准入信息修改为已邀请状态吗？`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              complete({
                'id': row.id
              }).then(data => {
                if (data && data.code === '00') {
                  this.$message({
                    message: '操作成功',
                    type: 'success',
                    duration: 1500,
                    onClose: () => {
                      this.getDataList()
                    }
                  })
                } else {
                  this.$message.error(data.msg)
                }
              })
            })
            // }
          },

            rowClassName({
                             row,
                             rowIndex
                         }) {
                //把每一行的索引放进row.id
                row.rowid = rowIndex + 1 + (this.pageSize * (this.pageIndex - 1));
            },
            //查看
            venderUserDetail(row) {
                this.temp = Object.assign({}, row) // copy obj
                this.editflag = true
                this.showEditButton = false
                this.venderinviteId = row.id
                this.dialogVisible = true
                this.supplierInquiryViewVisible = true

            },
            //关闭弹框的事件
            closeDialog() {
                this.getDataList()
            },
            updateHandle(row) {
                // if (row.venderStatus == '1') {
                //     this.$message.info("已邀请状态不能修改！")
                // } else {
                  console.log("为什么不能修改")
                    this.temp = Object.assign({}, row) // copy obj
                    console.log("temp",this.temp)
                    this.editflag = true
                    this.showEditButton = true
                    this.venderinviteId = row.id
                    this.dialogVisible = true
                    this.supplierInquiryViewVisible = true

                // }
            },


        }
    }
</script>

<style lang="scss">
    .fr { float: right; }
    .tab_style {
      min-height: 40vh;
    }
    .button-danger { color: #F56C6C; }
</style>